<style src="./image-content.css" />
<script src="./image-content.js"></script>
<script>
    export default {
        props: ['url', 'alt']
    }

</script>

<template>
  <picture class="image-content" >
     <img :src="url" :alt="alt">
  </picture>
</template>



// WEBPACK FOOTER //
// src/components/image-content/image-content.vue?620c3438